import PropTypes from 'prop-types'
import React from "react"
import {
  TvModalRoot,
  TvModalMain,
  TvCloseButton,
  TvDiv,
  TvI,
  TvP,
  TvButton,
} from "@trustvid/design-system"

const DeleteModal = ({
  show,
  onDeleteClick,
  onCloseClick,
  message,
  zIndex,
  modalClassName,
  backdropClassName,
}) => {
  return (
    <TvModalRoot
      size="md"
      isOpen={show}
      toggle={onCloseClick}
      centered
      zIndex={zIndex}
      modalClassName={modalClassName}
      backdropClassName={backdropClassName}
    >
      <TvDiv className="modal-content">
        <TvModalMain className="px-4 py-5 text-center">
          <TvCloseButton type="button" onClick={onCloseClick} className="position-absolute end-0 top-0 m-3" aria-label="Close" />
          <TvDiv className="avatar-sm mb-4 mx-auto">
            <TvDiv className="avatar-title bg-danger font-size-20 rounded-3">
              <TvI className="mdi mdi-trash-can-outline"></TvI>
            </TvDiv>
          </TvDiv>
          <TvP className="text-muted font-size-16 mb-4">{message}</TvP>

          <TvDiv className="hstack gap-2 justify-content-center mb-0">
            <TvButton color="danger" type="button" onClick={onDeleteClick}>Delete Now</TvButton>
            <TvButton color="secondary" type="button" onClick={onCloseClick}>Close</TvButton>
          </TvDiv>
        </TvModalMain>
      </TvDiv>
    </TvModalRoot>
  );
};

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.bool,
  message: PropTypes.string,
  zIndex: PropTypes.number,
  modalClassName: PropTypes.string,
  backdropClassName: PropTypes.string,
};

export default DeleteModal;
